// Homepage Configuration Constants
export const HOMEPAGE_CONFIG = {
  // Hero Section Configuration
  HERO: {
    title: 'Spiritual Services at Your Doorstep',
    subtitle: 'Book authentic poojas and ceremonies with verified pandits',
    description: 'Connect with experienced pandits for traditional rituals, festivals, and ceremonies. Available across major cities with transparent pricing.',
    searchPlaceholder: 'Search for poojas, ceremonies, festivals...',
    backgroundGradient: 'bg-gradient-to-br from-orange-50 via-amber-50 to-yellow-50',
    features: [
      { 
        icon: 'HOME', 
        title: 'Doorstep Service',
        description: 'Authentic ceremonies at home'
      },
      { 
        icon: 'VERIFIED', 
        title: 'Verified Pandits',
        description: 'Certified spiritual experts'
      },
      { 
        icon: 'SCHEDULE', 
        title: 'Flexible Scheduling',
        description: 'Book at your convenience'
      },
      { 
        icon: 'PRICING', 
        title: 'Transparent Pricing',
        description: 'No hidden charges'
      }
    ],
    cta: {
      primary: 'Book Now',
      secondary: 'Browse Services'
    }
  },

  // Sections Configuration
  SECTIONS: {
    CATEGORIES: {
      title: 'What are you looking for?',
      subtitle: 'Choose from our wide range of spiritual services',
      gridConfig: {
        mobile: 'grid-cols-2',
        tablet: 'sm:grid-cols-3',
        desktop: 'md:grid-cols-4',
        large: 'lg:grid-cols-6'
      }
    },
    POPULAR_SERVICES: {
      title: 'Most booked services',
      subtitle: 'Popular choices by our customers',
      showSeeAll: true,
      mobileLayout: 'horizontal-scroll', // or 'grid'
      gridConfig: {
        tablet: 'sm:grid-cols-2',
        desktop: 'md:grid-cols-3',
        large: 'lg:grid-cols-4'
      }
    },
    NEW_SERVICES: {
      title: 'New and noteworthy',
      subtitle: 'Latest spiritual services and offerings',
      badgeText: 'NEW',
      badgeColor: 'bg-green-100 text-green-700',
      gridConfig: {
        mobile: 'grid-cols-2',
        tablet: 'sm:grid-cols-2',
        desktop: 'md:grid-cols-4',
        large: 'lg:grid-cols-4'
      }
    },
    SPECIAL_OFFERS: {
      title: 'Special Offers',
      showTitle: false // Special offers don't have a section title in current design
    }
  },

  // Layout Configuration
  LAYOUT: {
    maxWidth: 'max-w-6xl',
    containerPadding: 'px-4',
    sectionSpacing: 'mb-16',
    heroSpacing: 'py-12',
    mainSpacing: 'py-12'
  },

  // Default Props
  DEFAULT_PROPS: {
    cartCount: 0,
    showTopBar: true,
    enableSearch: true,
    enableStats: true
  },

  // Event Types for better event handling
  EVENT_TYPES: {
    CATEGORY_CLICK: 'category_click',
    SERVICE_CLICK: 'service_click',
    SEARCH: 'search',
    SEE_ALL: 'see_all',
    BOOK_NOW: 'book_now',
    LOCATION_CLICK: 'location_click',
    USER_CLICK: 'user_click',
    CART_CLICK: 'cart_click',
    SIGNUP_USER: 'signup_user',
    SIGNUP_PANDIT: 'signup_pandit',
    LOGO_CLICK: 'logo_click'
  }
};

// Data Source Configuration - for dynamic data loading
export const DATA_CONFIG = {
  ENDPOINTS: {
    SERVICE_CATEGORIES: '/api/service-categories',
    POPULAR_SERVICES: '/api/popular-services',
    NEW_SERVICES: '/api/new-services',
    PLATFORM_STATS: '/api/platform-stats',
    SPECIAL_OFFERS: '/api/special-offers'
  },
  
  CACHE_CONFIG: {
    SERVICE_CATEGORIES: { ttl: 3600000 }, // 1 hour
    POPULAR_SERVICES: { ttl: 1800000 },   // 30 minutes
    NEW_SERVICES: { ttl: 3600000 },       // 1 hour
    PLATFORM_STATS: { ttl: 900000 },     // 15 minutes
    SPECIAL_OFFERS: { ttl: 1800000 }      // 30 minutes
  },

  FALLBACK_DATA: {
    // Fallback to imported static data if API fails
    useStaticFallback: true,
    staticDataPath: '../data/servicesData'
  }
};

// Responsive Breakpoints
export const RESPONSIVE_CONFIG = {
  BREAKPOINTS: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px'
  },
  
  GRID_PRESETS: {
    SERVICE_CATEGORIES: {
      base: 'grid-cols-2',
      sm: 'sm:grid-cols-3',
      md: 'md:grid-cols-4',
      lg: 'lg:grid-cols-6'
    },
    SERVICE_CARDS: {
      sm: 'sm:grid-cols-2',
      md: 'md:grid-cols-3',
      lg: 'lg:grid-cols-4'
    },
    NEW_SERVICES: {
      base: 'grid-cols-2',
      sm: 'sm:grid-cols-2',
      md: 'md:grid-cols-4'
    }
  }
};

// Animation and Transition Configuration
export const ANIMATION_CONFIG = {
  HOVER_EFFECTS: {
    SERVICE_CARD: 'hover:shadow-lg hover:scale-105',
    CATEGORY_CARD: 'hover:shadow-md hover:-translate-y-1',
    BUTTON: 'hover:shadow-sm'
  },
  
  TRANSITIONS: {
    DEFAULT: 'transition-all duration-200 ease-in-out',
    FAST: 'transition-all duration-150 ease-in-out',
    SLOW: 'transition-all duration-300 ease-in-out'
  },

  LOADING_STATES: {
    SKELETON_SHIMMER: 'animate-pulse bg-gray-200',
    FADE_IN: 'animate-fadeIn',
    SLIDE_UP: 'animate-slideUp'
  }
};
